/**
 * useSelectedReleaseRun Hook
 *
 * @module features/releases/hooks/useSelectedReleaseRun
 * @description The timeline's master-detail selection — reads `?runId=` off
 * the property route's own search params and writes it back with `replace:
 * true` so selecting a band doesn't grow the history stack. The default (no
 * `?runId=`) is derived by the caller (`pickDefaultRunId`), never written
 * here — see `ReleasePropertyTimeline`.
 */

import { useNavigate, useSearch } from '@tanstack/react-router';

export function useSelectedReleaseRun(propertyId: string) {
  const search = useSearch({ from: '/releases/$propertyId' });
  const navigate = useNavigate();

  const selectRun = (runId: string | null) => {
    void navigate({
      to: '/releases/$propertyId',
      params: { propertyId },
      search: (prev: Record<string, unknown>) => ({ ...prev, runId: runId ?? undefined }),
      replace: true,
    });
  };

  return { selectedRunId: search.runId ?? null, selectRun };
}
